function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    fill: "none",
    viewBox: "0 0 12 15"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.005 6.165h-8.01a.89.89 0 0 0-.89.89v6.23c0 .492.398.89.89.89h8.01a.89.89 0 0 0 .89-.89v-6.23a.89.89 0 0 0-.89-.89M2.885 6.165V3.94a3.115 3.115 0 0 1 6.23 0v2.225M6 9.28v1.78"
  }));
};
export default SvgLock;